import { applyMiddleware, compose, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native
import reducers from "./reducers";
import thunk from "redux-thunk";
import LogRocket from "logrocket";

import { jwt } from "../middlewares/jwt";

const persistConfig = {
	key: "root",
	storage,
	blacklist: []
};

declare global {
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any;
	}
}

const persistedReducer = persistReducer(persistConfig, reducers);

const composeEnhancers =
	typeof window === "object" && window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
		? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({})
		: compose;

export default () => {
	const store = configureStore({
		reducer: persistedReducer,
		middleware: [
			jwt,
			thunk,
			LogRocket.reduxMiddleware({
				actionSanitizer: (action: any) => {
					if (action.payload) {
						if (action.payload.password) action.payload.password = null;
						if (action.payload.login) {
							if (action.payload.login.password)
								action.payload.login.password = null;
							// if (action.payload.login.token) action.payload.login.token = null;
						}
					}

					return action;
				}
				// stateSanitizer: state => {
				//   state = { ...state };
				//   if (state.login) {
				//     if (state.login.password) state.login.password = null;
				//     if (state.login.token) state.login.token = null;
				//   }

				//   return state;
				// }
			})
		]
	}) as any;
	const persistor = persistStore(store);
	return { store, persistor };
};
